import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization } from "../ApiMethod/ApiMethod";

export const GetDailyPujaDetailsBySlug = async (slug, LangID) => {
    const url = `${BaseUrl}/GetDailyPujaDetailsBySlug?Slug=${slug}&LangID=${LangID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};